import React, { FC, PropsWithChildren, useState } from 'react';
import classNames from 'classnames';
import { restrictToParentElement } from '@dnd-kit/modifiers';
import { SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import {
  closestCenter,
  DndContext,
  DragOverlay,
  PointerSensor,
  UniqueIdentifier,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

import { DEFAULT_VERTICAL_PROPS, ShiftSpaceKeyboardSensor } from './constants';

import { DraggableContextProps } from './interfaces';

import useStyles from './style';

const DraggableContext: FC<PropsWithChildren<DraggableContextProps>> = ({
  items,
  dndType,
  onDragEnd,
  children,
  preview,
  strategy = DEFAULT_VERTICAL_PROPS.strategy,
  modifiers = DEFAULT_VERTICAL_PROPS.modifiers,
}) => {
  const classes = useStyles();

  const [activeIdx, setActiveIdx] = useState<Nullable<UniqueIdentifier>>(null);

  // const selectedIdsContext = useSelectList();

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(ShiftSpaceKeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return (
    <DndContext
      autoScroll={{
        enabled: true,
        canScroll: container => !container.classList.contains('eventLayoutContainer'),
      }}
      sensors={sensors}
      collisionDetection={closestCenter}
      modifiers={[restrictToParentElement, ...modifiers]}
      onDragEnd={e => {
        onDragEnd(e);
        setActiveIdx(null);
      }}
      onDragStart={event => setActiveIdx(event.active.data.current?.sortable.index)}
      onDragCancel={() => setActiveIdx(null)}
    >
      <SortableContext id={dndType} items={items} strategy={strategy}>
        {children}
      </SortableContext>
      <DragOverlay
        dropAnimation={null}
        className={classNames('content-fade-in ready dragOverlay', classes.dragOverlay)}
      >
        {preview(activeIdx as number)}
        {/* {selectedIdsContext?.selectedIds.length > 1 ? (
            <div> {selectedIdsContext.selectedIds.length} items selected</div>
          ) : isNull(activeIdx) ? null : (
            preview(activeIdx as number)
          )} */}
      </DragOverlay>
    </DndContext>
  );
};

export default DraggableContext;
